import { FC } from 'react';
import { Alert } from '@mui/material';
import { AlertTriangle, Calendar } from 'react-feather';
import Link from '@/components/Link/Link';

interface CalendarAlertProps {
  className?: string;
  requestedVerbiage?: boolean;
  addCalendarLink?: boolean;
  rovoMessaging?: boolean;
  warningIcon?: boolean;
}

export const CalendarAlert: FC<CalendarAlertProps> = ({
  className,
  requestedVerbiage = true,
  addCalendarLink = false,
  rovoMessaging = false,
  warningIcon = false,
}) => {
  return (
    <Alert
      data-testid="calendar-alert"
      icon={
        warningIcon ? (
          <AlertTriangle data-testid="calendar-alert-warning-icon" size={30} color="#E6740A" />
        ) : (
          <Calendar data-testid="calendar-alert-calendar-icon" size={20} color="#E6740A" />
        )
      }
      severity="warning"
      className={className}
      sx={{
        backgroundColor: '#FAE4D0',
        color: '#3D3D3D',
        border: '1px solid #E6740A',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 400,
        alignItems: 'center',
        padding: '11px 16px',
        minHeight: '42px',
        '& .MuiAlert-icon': {
          color: '#E6740A',
          fontSize: '20px',
          padding: 0,
          marginRight: '12px',
          opacity: 1,
        },
        '& .MuiAlert-message': {
          padding: 0,
          display: 'flex',
          alignItems: 'center',
        },
      }}
    >
      {rovoMessaging ? (
        <div>
          Redeem and visible changes take effect immediately. Price changes will take effect weekly. Check calendar for
          blackouts.
        </div>
      ) : (
        <div>
          {requestedVerbiage ? <span>Requested c</span> : <span>C</span>}hanges will take effect weekly. Check
          {addCalendarLink ? <Link to="/calendar">calendar</Link> : <span> calendar </span>}
          for blackouts.
        </div>
      )}
    </Alert>
  );
};
